<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12">
      <p-accordion id="accordion" [multiple]="false" (onOpen)="abrirAcordeon($event)">
        <p-accordionTab header="{{ 'FASES.LBL_INFOFASE' | translate }}" [selected]="tabSeleccionado === 'INFO'">
          <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="idFormulario" name="nomFormulario">
            <div class="grid form-group">
              <div class="col-12 md:col-6 lg:col-6">
                <div class="div-form">
                  <label>* {{ 'FASES.LBL_CODIGO' | translate }}</label>
                  <input type="text" pInputText id="codigo"
                         name="nomCodigo"
                         autocomplete="off"
                         formControlName="codigo"
                         maxlength="10"
                         (blur)="validarCodigo()"
                         codigos-reactive
                  >
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.codigo.invalid">
                    {{ 'CANALES.LBL_CODIGO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="codExiste">
                    {{ 'CANALES.MSG_CODIGOEXISTE' | translate}}
                  </div>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-6">
                <div class="div-form">
                  <label>* {{ 'FASES.LBL_NOMBRE' | translate }}</label>
                  <input type="text" pInputText id="nombre"
                         name="nomNombre"
                         autocomplete="off"
                         formControlName="nombre"
                         [maxlength]="50"
                         capitalize-reactive
                  >
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.nombre.invalid">
                    {{ 'FASES.LBL_NOMBRE' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
              </div>
            </div>
            <div class="grid form-group">
              <div class="col-12 md:col-6 lg:col-6">
                <p-checkbox label="{{ 'FASES.LBL_FASEINICIAL' | translate}}" binary="true"
                            id="idIndicadorInicial"
                            name="nomIndicadorInicial"
                            formControlName="indicadorInicial"></p-checkbox>
              </div>
              <div class="col-12 md:col-6 lg:col-6">
                <p-checkbox label="{{ 'LBL_HABILITADO' | translate}}" binary="true"
                            id="indicador"
                            name="nomIndicador"
                            formControlName="indicadorHabilitado"></p-checkbox>
              </div>
            </div>
            <div class="grid form-footer-buttons">
              <div class="form-group col-12">
                <div *ngIf="!guardando">
                  <a (click)="regresar(formulario.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
                  <button icon="fa fa-plus" label="{{'BTN_GUARDAR' | translate }}"
                          type="submit"
                          pButton></button>
                </div>
                <div *ngIf="guardando">
                  <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                  <span>{{'LBL_GUARDANDO' | translate }}</span>
                </div>
              </div>
            </div>
          </form>
        </p-accordionTab>
        <p-accordionTab header="{{ 'FASES.LBL_RELACIONES' | translate }}" [selected]="tabSeleccionado === 'RELACIONES'" [disabled]="!fase">
          <app-fase-estado [fase]="fase" *ngIf="fase"></app-fase-estado>
        </p-accordionTab>
      </p-accordion>
    </div>
  </div>
  <div class="grid form-footer-buttons" *ngIf="fase && fase.idFase">
    <div class="form-group col-12">
      <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button"
              pButton (click)="regresar(formulario.dirty)"></button>
    </div>
  </div>
</div>

<p-confirmDialog #cd key="fase">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
